import React from 'react';
import PreLoginPage from '../../views/core/PreLoginPage';
import '../../css/LoginForm.css';
import $ from 'jquery';

import { FormWithConstraints, FieldFeedback } from 'react-form-with-constraints';
import { FieldFeedbacks, FormGroup, FormControlLabel, FormControlInput } from 'react-form-with-constraints-bootstrap4';
import HmAjax from '../../util/HmAjax';
import NativeAjax from '../../util/NativeAjax';
import { isMobile, isTablet, isBrowser } from 'react-device-detect';
import BrowserStorageUtil from '../../util/BrowserStorageUtil';
import MobileSignup from './MobileSignUp';
import MobileForgotPwd from './MobileForgotPwd';
import ReactHtmlParser from 'react-html-parser';

var loginServerResponses = {
	200: 'Success.',
	600: 'User ID expired.',
	700: 'Invalid User ID or Password.',
	500: 'An unexpected error occurred. Please try again after sometime or write to <a href="mailto:<email>"><email></a>.',
	0: 'An unexpected error occurred. Please try again after sometime or write to <a href="mailto:support@heymath.com">support@heymath.com</a>.'
};

class MobileLogin extends PreLoginPage {

	constructor(props) {
		super(props);
		//this.props.userid || 
		this.state = {
			plp_userinput: "",
			password: '',
			submitButtonDisabled: false,
			serverMessage: this.props.errMsg || "",
			source: "",
			loginType: this.props.loginType || "mobile",
			userLoginAllowed: false,
			newUserSignup:false,
			dataLoaded:false,
			passwordchange:false,
			resetpassword:false,
            passwordType:"password"
		};
		this.modalcloseDataGA = "";
		this.handleChange = this.handleChange.bind(this);
		this.userIdChange = this.userIdChange.bind(this);
		this.handlePasswordChange = this.handlePasswordChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.myTrackerInstance = this.getTracker();

		this.navigationKey = "PLP_Navigation";

		this.navigateUrl = props.navigateURL || window.location.href;


		this.gaFrom = this.props.gaFrom;
		this.gasignin = " - Returning User";
		//console.log("this.gaFrom:::::::::::",this.gaFrom);
		if (this.gaFrom == "Top" || this.gaFrom == "Bottom") {
			this.gaFrom = this.gaFrom + " Home - Join";
		} else {
			this.gaFrom = "Sign In - Users who have independently registered";
			this.gasignin = "";
		}
		this.pwdIframeView = null;
		//console.log("this.gaFrom2222:::::::::::",this.gaFrom);
		//console.log("MobileLogin Loading"+(this.navigateUrl || 'None'));  
	}
	componentWillReceiveProps(nextProps) {
		var me = this;
		//console.log('componentWillReceiveProps', nextProps);  nextProps.userid ||  
		this.setState({
			plp_userinput:  "",
			password: '',
			submitButtonDisabled: false,
			serverMessage: "",
			source: "",
			loginType: nextProps.loginType || "mobile"
		});

		this.gaFrom = nextProps.gaFrom;
		// console.log("this.gaFrom:::::::::::",this.gaFrom);
		if (this.gaFrom == "Top" || this.gaFrom == "Bottom") {
			this.gaFrom = this.gaFrom + " Home - Join";
		} else {
			this.gaFrom = "Users who have independently registered - Sign Up";
		}

		//console.log("this.gaFrom:::::::::::",this.gaFrom);
		// console.log("MobileLogin Testing"+(this.navigateUrl || 'None'));  
	}
	componentDidMount() {
		$(".PreLogin header").css("display","none");
		$(".socialLoginContainer").hide();
		this.appendCSS("./vendors/remedial.css");
		//console.log("props ",this.props)
		this.sessionCheck();
		setTimeout(()=>{
			this.setState({dataLoaded:true});
		},1000)
	}


	handleChange(e) {
		let me=this;
		const target = e.currentTarget;
		this.form.validateFields(target);
		
		this.setState({
			[target.name]: target.value
		},
		()=>{
			//console.log("handleChange ",target.value.length);
			if(target.value.length === 10){
				me.setState({
					submitButtonDisabled: false
				});
			}else{
				me.setState({
					submitButtonDisabled: true
				});
			}
		});

		
	}

	userIdChange(e) {
		const target = e.currentTarget;
		//console.log("userIdChange ",target);
		var phoneRegx = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g;
		if (phoneRegx.test(target.value)) {
			this.setState({ loginType: "mobile", serverMessage: "" });
		} else {
			this.setState({ loginType: "email", serverMessage: "" });
		}
		this.handleChange(e);
	}

	handlePasswordChange(e) {
		let me=this;
		const target = e.currentTarget;
		this.form.validateFields(target);
		
		this.setState({
			[target.name]: target.value,
			submitButtonDisabled: !this.form.isValid(),
			serverMessage: ""
		});
	}

	hmNav = function (userobj) {
		if (this.navigateUrl === null) {
			// Do nothing
		} else if (this.navigateUrl == "/product-details") {
			window.top.location.href = this.navigateUrl;
		} else {
			if (this.productsAvailableToAccess(userobj)) {
				window.top.location.href = "/landing";
			} else {
				if (userobj && userobj.userRole && userobj.userRole.role && userobj.userRole.role.toUpperCase() === "TCHR") {
					window.top.location.href = "/teachers";
				} else {
					window.top.location.href = this.navigateUrl;
				}
			}
		}

	}

	productsAvailableToAccess(userobj) {
		var user = userobj;
		//console.log("user::::",user);
		if (user != null) {
			var permissions = user.entlHistory;//console.log("permissions:::",permissions);
			if (permissions != null && Object.keys(permissions).length > 0) {
				for (var i in permissions) {
					if (permissions[i] != null) {
						var totalLevel = permissions[i].split(",").reduce(function (a, b) {
							try {
								return parseInt(a) + parseInt(b);
							} catch (e) {
								return 0;
							}
						});

						if (totalLevel > 0) {
							return true;
						}
					}
				}
			}
		}

		return false;
	}

	storeRedirectUrl() {
		let redirectUrl = null;
	}

	//testplpum.heymath.com/additionalInfo/update
	updateUserType(commonCallback) {
		var me = this;
		var callBackSuccess = function (response) {
			if (response !== null) {
				//console.warn("user type",response)
				me.getUser().store(response);
			}

			if (typeof commonCallback === "function") {
				commonCallback.apply(this, [response]);
			}
		}

		var callBackFailure = function (response) {
			//console.warn("failure ",response);

			if (typeof commonCallback === "function") {
				commonCallback.apply(this);
			}
		}

		super.updateUserType(callBackSuccess, callBackFailure)
	}

	unifiedSubmitForm = function () {
		var formData = {
			"userId": this.state.plp_userinput,
			"password": this.state.password
		}


		var me = this;
		me.setState({ submitButtonDisabled: true });


		var callBackSuccess = function (response) {

			if (response !== null) {
				//console.warn("login response in",response);
				if (response.source == "plp") {
					if (response.authenticated) {
						//Setting user object at the browser level

						me.getUser().store(response.user);
						if(window.remedialAllowFilter){
							BrowserStorageUtil.storeItem("remedial", true);
						}
						
						me.storeRedirectUrl();

						try {
							me.doLumosLogout();
						} catch (e) { }
						me.setState({ submitButtonDisabled: false, source: response.source });
						try {
							var userObj = response.user;
							var loginObj = {
								"user_id": (userObj == null) ? "" : userObj.userId,
								"login_id": me.state.plp_userinput,
								"user_agent": navigator.userAgent,
								"platform": navigator.platform,
								"device": isMobile ? "mobile" : (isTablet ? "tablet" : "PC"),
								"ip_address": "ip_address",
								"result": true,
								"session_id": (userObj == null) ? "" : userObj.authToken
							}

							me.storeTrackEvent("login", loginObj);
						} catch (e) { }


						if (!me.tracked) {
							me.getAdsTracker().callByReferer({ "eventType": "trackCustom", "eventName": "logged-in" });
							me.tracked = true;
						}

						let afterUpdate = function (response) {
							if (typeof me.props.callBack === "function") {
								me.props.callBack(response);
								return;
							}

							me.hmNav(response);
						};
						me.updateUserType(afterUpdate);
					} else {
						if (response.message == "provider_forbidden") {
							me.setState({ submitButtonDisabled: false, serverMessage: me.rb("google.errmsg.login") });
						} else {
							me.setState({ submitButtonDisabled: false, serverMessage: me.rb(response.message) });
						}
						//me.showAlert(me.rb("alert"),me.rb(response.message));
						me.trackMe(false);
					}
				}
				else if (response.source == "lumos") {
					try {
						me.doPLPLogout();
					} catch (e) { }

					switch (response.code) {
						case 200:
						case 402:
							me.setState({ source: response.source });
							window.top.location.href = response.link;
							break;
						case 500:
							//currentDialog.serverMessageElem.innerHTML = loginServerResponses[response.codeus].replace(/<email>/g, response.link);
							me.setState({ submitButtonDisabled: false, serverMessage: loginServerResponses[response.code].replace(/<email>/g, response.link) });
							break;
						case 600:
						case 700:
							//currentDialog.serverMessageElem.innerHTML = loginServerResponses[response.code];
							me.setState({ submitButtonDisabled: false, serverMessage: loginServerResponses[response.code] });
							break;
						default:
							//currentDialog.serverMessageElem.innerHTML = loginServerResponses[0];
							me.setState({ submitButtonDisabled: false, serverMessage: loginServerResponses[0] });
					}
				}
			}
		}

		var PLPcallBackFailure = function (response) {
			//console.log("response : ", response);
			me.trackMe(false);
			me.setState({ submitButtonDisabled: false });
		}

		var callBackFailure = function (response) {
			//console.log("response : ", response);
			//me.trackMe(false);
			//me.setState({submitButtonDisabled: false});
			new NativeAjax(me.getUrlFor("PLP_COMMON_LOGIN"), formData).enableCORS().post(callBackSuccess, PLPcallBackFailure);
		}

		//new HmAjax(this.getUrlFor("LOGIN"),formData).post(callBackSuccess,callBackFailure);
		new NativeAjax(this.getUrlFor("LUMOS_COMMON_LOGIN"), formData).enableCORS().post(callBackSuccess, callBackFailure);
		me.getUser().clearOldUser();

	}

	getUserStatus() {

		if (this.state.plp_userinput.length <= 0) {
			return;
		}

		var formData = {
			"verificationId": this.state.plp_userinput
		}
		this.setState({ submitButtonDisabled:true});
		var me = this;
		var callBackSuccess = function (response) {
			if (response !== null) {
				//console.log("response : ", response,"me.props.from:::",me.props.from);					
				if (response.user_exists) {
					me.setState({ userLoginAllowed: true });
				} else {
					if (response.message == "provider_forbidden") {
						me.setState({ submitButtonDisabled: false, serverMessage: me.rb("google.errmsg.login") });
					} else {
						//me.setState({userLoginAllowed:false});
						//me.props.showSignUp(me.state.loginType,me.state.plp_userinput,me.props.from);
						me.checkValidUserInput();
					}
				}
			}


		}

		var callBackFailure = function (response) {
			//console.log("response : ", response);	
			me.setState({ submitButtonDisabled: false });
		}

		new HmAjax(this.getUrlFor("GET_USER_STATUS") + this.state.loginType, formData).post(callBackSuccess, callBackFailure);

	}
	checkValidUserInput() {
		var me = this;
		var userinput = this.state.plp_userinput;
		var phoneRegx = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g;

		if (phoneRegx.test(userinput)) {
			if (userinput.length == 10) {
				me.setState({ userLoginAllowed: false,newUserSignup:true,passwordchange:true });
				//me.mobileUIOTP(me.state.loginType, me.state.plp_userinput, me.props.from);
				//me.mobileUIOTPForgotPwd(me.state.loginType, me.state.plp_userinput, me.props.from);
				//me.props.showSignUp(me.state.loginType, me.state.plp_userinput, me.props.from);
			} else {
				me.setState({ submitButtonDisabled: false, serverMessage: me.rb("login.invalidinput.msg") });
			}
		} else {
			if (userinput.match(/^[a-zA-Z0-9_+\-%]+[a-zA-Z0-9_.+\-%]+[a-zA-Z0-9_+\-%]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/)) {
				me.setState({ userLoginAllowed: false,newUserSignup:true,passwordchange:true });
				//me.mobileUIOTP(me.state.loginType, me.state.plp_userinput, me.props.from);
				//me.mobileUIOTPForgotPwd(me.state.loginType, me.state.plp_userinput, me.props.from);				
				//me.props.showSignUp(me.state.loginType, me.state.plp_userinput, me.props.from);
			} else {
				me.setState({ submitButtonDisabled: false, serverMessage: me.rb("login.invalidinput.msg") });
			}
		}
	}
	doLumosLogout() {
		super.doLumosLogout();
	}

	doPLPLogout() {
		var me = this;
		var callBackSuccess = function (resp) {
			me.UserStore.clearOldUser();
			//me.initiateTrack("logout",{});

			// setTimeout(function(){
			// 	me.UserStore.clearOldUser();
			// 	window.location.href = me.getUrlFor("PRELOGIN_PAGE");
			// },500);
		}

		var callBackFailure = function (resp) {
			console.error("Logout failed.");
		}

		super.doPLPLogout(callBackSuccess, callBackFailure);
	}

	handleSubmit(e) {
		e.preventDefault();

		this.form.validateFields();

		this.setState({ submitButtonDisabled: !this.form.isValid() });

		if (this.form.isValid()) {
		
			if(this.state.userLoginAllowed){
				this.unifiedSubmitForm();
			}else{
				this.getUserStatus();
			}
		}
	}

	trackMe(result, userObj = null) {
		var trackObj = {
			"user_id": (userObj == null) ? "" : userObj.userId,
			"login_id": this.state.plp_userinput,
			"user_agent": navigator.userAgent,
			"platform": navigator.platform,
			"device": isMobile ? "mobile" : (isTablet ? "tablet" : "PC"),
			"ip_address": "ip_address",
			"result": (result === true),
			"session_id": (userObj == null) ? "" : userObj.authToken
		}

		this.initiateTrack("login", trackObj);
	}

	updateOTPCall = () => {
		this.setState({userLoginAllowed:true});
	}

	mobileUIOTP = (navigateurl = null, freetrail = null) => {
		let loginType = "mobile";
		let userInput =  this.state.plp_userinput;
		if (navigateurl == null) {
			navigateurl = '/products';
		}
		console.log("calling signup this.gaFrom:::", this.gaFrom);
		return (
			<MobileSignup callFrom={"signup"} backFn={this.loginPageFn} callBackParent={this.updateOTPCall} signupUser={"student"} myProps={this.props} loginType={loginType} data-ga={this.modalcloseDataGA} userInput={userInput} successRegisterMsg={this.showsuccessRegisterMsg} navigateURL={navigateurl} freetrail={freetrail} gaFrom={this.gaFrom} />
		);
	}

	mobileUIOTPForgotPwd = (navigateurl = null, freetrail = null) => {
		let loginType = "mobile";
		let userInput =  this.state.plp_userinput;
		if (navigateurl == null) {
			navigateurl = '/products';
		}
		console.log("calling signup this.gaFrom:::", this.gaFrom);
		return (
			<MobileForgotPwd callFrom={"forgotPWD"} backFn={this.loginPageFn} callBackParent={this.updateOTPCall} signupUser={"student"} myProps={this.props} loginType={loginType} data-ga={this.modalcloseDataGA} userInput={userInput} successRegisterMsg={this.showsuccessRegisterMsg} navigateURL={navigateurl} freetrail={freetrail} gaFrom={this.gaFrom} />
		);
	}

	getSuccessPwdMsg = (msg) => {
		return (
			<div className="successPwdMsg text-center">{ReactHtmlParser(msg)}</div>
		);
	}

	loginPageFn = () => {
		this.setState({serverMessage:"",plp_userinput:"",password:"",submitButtonDisabled: false,newUserSignup:false,userLoginAllowed:false,resetpassword:false,dataLoaded:true});
	}

	resetpasswordFn = () => {
		this.setState({newUserSignup:false,userLoginAllowed:false,dataLoaded:false,resetpassword:true});
	}
	

	mobileUILogin = () => {
		let me=this;
		let submitbtnAddCls = this.state.submitButtonDisabled ? " grey" : " teal";
		//console.log("submitbtnAddCls ",this.state.submitButtonDisabled);
		return(
		<div className="row mobilenomargin loginMob">
					<div className="col-sm-12 nopadding mob-banner">
						<h1 className="login-title">{this.rb("login.title")}
						<span><img src={'img/remedialMobile/icons/icons_happy.png'}></img></span></h1>
					</div>
	
					<div id="loginMobile" className="remedialLogin col-sm-12">
	
						<div className="container">
	
									<div className="row">
										<div className="col-md-12 mx-auto nopadding">
											<div className="rounded-0">
											<span className="inputLabel">{this.rb("login.number")}</span>
												<div className="text-center ">
												   
													<FormWithConstraints ref={formWithConstraints => this.form = formWithConstraints}
														onSubmit={this.handleSubmit} noValidate>
															

														<FormGroup for="plp_userinput">
															 {(() => {
																if (this.state.loginType == "mobile") {
																	return (
																		<span className="countrycode">+91</span>
																	);
																}
															})()} 
															<div className="phone-icon"><img src={'img/remedialMobile/icons/icons8-phone.png'}></img></div>
															<FormControlInput type="number" className={"plp_userinput " + this.state.loginType} name="plp_userinput" placeholder="Mobile Number"
																value={this.state.plp_userinput} onChange={this.userIdChange}
																required minLength={1} pattern=".{10,}" maxLength={20} autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="3" />
															
															<FieldFeedbacks for="plp_userinput">
																<FieldFeedback when="valueMissing">{this.rb("register.mobilerequired")}</FieldFeedback>
																<FieldFeedback when={value => (value.length>0 && value.length<10)}>{this.rb("register.mobilenolength")}</FieldFeedback>
																{/* <FieldFeedback when={value => (value.length>0 && !/\d/.test(value))}>{this.rb("register.numbersonly")}</FieldFeedback> */}
																<FieldFeedback when="*" />
															</FieldFeedbacks>
															
														</FormGroup>
	
	
														<div className="server-messges">{me.state.serverMessage}</div>
	
														<button data-ga={"Home - " + me.gaFrom + me.gasignin + "  - Sign In"} disabled={me.state.submitButtonDisabled} className={"submitButton"+submitbtnAddCls}>{this.rb("login.btn.next")}</button>
													</FormWithConstraints>
												</div>
											</div>
										</div>
	
	
									</div>
	
								</div>
							</div>
						</div>
				
		)
	}

	revealPasswordFn = () => {
		let passwordType = (this.state.passwordType ==="password") ?  "text" : "password";
        this.setState({passwordType:passwordType});
    }

	mobileUIPassword = () => {
		let me=this;
		let submitbtnAddCls = this.state.submitButtonDisabled ? " grey" : " teal";
		let passwordIcon = this.state.passwordType === "password" ? 'img/remedialMobile/icons/icons_invisible.png' : 'img/remedialMobile/icons/icons_visible.png';
		//console.log("submitbtnAddCls ",this.state.submitButtonDisabled);
		return(
		<div className="row mobilenomargin passwordMob">
					<div className="col-sm-12 nopadding mob-banner">
		<div className="backbtn" onClick={me.loginPageFn}><img src={'img/remedialMobile/icons/arrow.png'}></img></div>
						<h1 className="password-title">{this.rb("password.title")}</h1>
					</div>
	
					<div id="pwdMobile" className="remedialPassword col-sm-12">
	
						<div className="container">
	
									<div className="row">
										<div className="col-md-12 mx-auto nopadding">
											<div className="rounded-0">
											<span className="inputLabel">{this.rb("password.input")}</span>
												<div className="text-center ">
												   
												<FormWithConstraints ref={formWithConstraints => this.form = formWithConstraints}
													onSubmit={this.handleSubmit} noValidate>

														<div>
															<FormGroup for="password">
															<div className="pwd-icon" onClick={this.revealPasswordFn}><img src={passwordIcon}></img></div>
																<FormControlInput type={this.state.passwordType} className="password" name="password" placeholder={this.rb("login.password")}
																	innerRef={password => this.password = password}
																	value={this.state.password} onChange={this.handlePasswordChange}
																	required minLength={1} maxLength={50} tabIndex="4" />
																	
																<FieldFeedbacks for="password" show="all">
																	<FieldFeedback when="valueMissing">{this.rb("login.pwdrequired")}</FieldFeedback>
																</FieldFeedbacks>
															</FormGroup>
															
														</div>
													<div className="server-messges">{me.state.serverMessage}</div>

													<button data-ga={"Home - " + me.gaFrom + me.gasignin + "  - Sign In"} disabled={me.state.submitButtonDisabled} className={"submitButton"+submitbtnAddCls}>Login</button>
													<div data-ga={"Home - " + this.gaFrom + this.gasignin + " - Forgot Password"} className="ufd-forgotPassword" onClick={this.resetpasswordFn}>
														{this.rb("mobile.forgot_password")}
													</div>
												</FormWithConstraints>
												</div>
											</div>
										</div>		
									</div>
								</div>
							</div>
						</div>
				
		)
	}
	
	render() {
		if (this.state.loggedIn) {
			return super.render();
		}else if(this.state.userLoginAllowed){
			return this.mobileUIPassword()
		}else if(this.state.newUserSignup){
			return this.mobileUIOTP()
		}else if(this.state.resetpassword){
			return this.mobileUIOTPForgotPwd()
		}else if(this.state.dataLoaded){
			return this.mobileUILogin()
		}else{
			return this.showLoader()
		}
	}
}

export default MobileLogin;


// WEBPACK FOOTER //
// ./src/views/login/MobileLogin.js